// Jewellery Admin navigation, shared by the desktop sidebar (BaseLayout)
// and the mobile drawer (AppHeader) so both always list the same options.
export default [
  {
    menu: {
      name: "DASHBOARD",
      route: "/JewelleryDashboard",
      src: require("../assets/icons/Home.png"),
    },
  },
  {
    menu: {
      name: "PURCHASE",
      route: "/PurchaseList",
      src: require("../assets/icons/Buy.png") ,
    },
  },
  {
    menu: {
      name: "ISSUE & RECEIPT",
      route: "/IssueReceiptList",
      src: require("../assets/icons/Buy.png") ,
    },
  },
  {
    menu: {
      name: "CONVERSION",
      route: "/ConversionList",
      src: require("../assets/icons/Buy.png") ,
    },
  },
  {
    menu: {
      name: "STOCK",
      route: "/StockPage",
      src: require("../assets/icons/Swap.png"),
    },
  },
  {
    menu: {
      name: "BILLING",
      route: "/SalesList",
      src: require("../assets/icons/moneysend.png"),
    },
  },
  {
    menu: {
      name: "ESTIMATE",
      route: "/EstimatePage",
      src: require("../assets/icons/statusup.png"),
    },
  },
  {
    menu: {
      name: "SALES HISTORY",
      route: "/SalesPage1",
      src: require("../assets/icons/Paper.png"),
    },
  },
  {
    menu: {
      name: "CUSTOMER",
      route: "/Customer",
      src: require("../assets/icons/3User.png"),
    },
  },
  {
    menu: {
      name: "SUPPLIER",
      route: "/Supplier",
      src: require("../assets/icons/Profile.png"),
    },
  },
  {
    menu: {
      name: "STAFF",
      route: "/staff",
      src: require("../assets/icons/2User.png"),
    },
  },
  {
    menu: {
      name: "CATEGORY",
      route: "/Category",
      src: require("../assets/icons/Filter.png"),

    },
  },
  {
    menu: {
      name: "HSN",
      route: "/hsnCode",
      src: require("../assets/icons/Edit.png"),

    },
  },
  {
    menu: {
      name: "GOLD SCHEME",
      route: "/GoldScheme",
      src: require("../assets/icons/Bag.png"),

    },
  },
  {
    menu: {
      name: "SCHEME LIST",
      route: "/CustomerSchemeList",
      src: require("../assets/icons/Bookmark.png"),

    },
  },
  {
    menu: {
      name: "OLD GOLD",
      route: "/AcidingList",
      src: require("../assets/icons/glass.png"),
    },
  },
  {
    menu: {
      name: "BOARDING RATE",
      route: "/BoardingRate",
      src: require("../assets/icons/moneys.png"),
    },
  },
  {
    menu: {
      name: "ACCOUNT HEADS",
      route: "/AccountHeads",
      src: require("../assets/icons/Buy.png") ,
    },
  },
  {
    menu: {
      name: "ACCOUNTS",
      route: "/Accounts",
      src: require("../assets/icons/Buy.png") ,
    },
  },
  {
    menu: {
      name: "TRIAL BALANCE",
      route: "/TrialBalance",
      src: require("../assets/icons/Buy.png") ,
    },
  },
  {
    menu: {
      name: "PROFIT & LOSS",
      route: "/ProfitAndLoss",
      src: require("../assets/icons/Buy.png") ,
    },
  },
  {
    menu: {
      name: "BALANCE SHEET",
      route: "/BalanceSheet",
      src: require("../assets/icons/Buy.png") ,
    },
  },
  {
    menu: {
      name: "REPORT",
      route: "",
      src: require("../assets/icons/Paper.png"),
      subMenuCategories: [
        {
          categoryName: "STOCK & PURCHASE",
          reports: [
            { name: "STOCK REPORT", route: "/StockPage" },
            { name: "STOCK SUMMARY", route: "/StockSummary" },
            { name: "PURCHASE REPORT", route: "/PurchaseList" },
            { name: "SUPPLIER WISE REPORT", route: "/SupplierWiseReport" },
            { name: "DAILY STOCK REPORT", route: "/DailyStockReport" },
          ]
        },
        {
          categoryName: "SALES & STAFF",
          reports: [
            { name: "SALES REPORT", route: "/SalesPage1" },
            { name: "SALES ITEM REPORT", route: "/salesReport" },
            { name: "SALESMAN WISE REPORT", route: "/SalesmanWiseReport" },
            { name: "DAILY SALES REPORT", route: "/DailySalesReport" },
            { name: "DAILY SUMMARY", route: "/DailySummary" },
          ]
        },
        {
          categoryName: "FINANCIALS",
          reports: [
            { name: "ACCOUNTING VOUCHERS REPORT", route: "/AccountingVouchersReport" },
            { name: "ADVANCES' REPORT", route: "/AdvancesReport" },
            { name: "CREDITORS' REPORT", route: "/CreditorsReport" },
            { name: "DAILY ISSUE & RECEIPT REPORT", route: "/DailyIssueReceiptReport" },
          ]
        },
        {
          categoryName: "OLD GOLD & SCHEMES",
          reports: [
            { name: "OLD GOLD REPORT", route: "/oldGoldList" },
            { name: "OLD GOLD STATEMENT", route: "/OldGoldStatement" },
            { name: "ACIDING REPORT", route: "/AcidingReport" },
            { name: "GOLD SCHEME REPORT", route: "/GoldSchemeReport" },
          ]
        }
      ]
    },
  },
  {
    menu: {
      name: "SETTINGS",
      route: "/MenuManagement",
      src: require("../assets/icons/Setting.png"),
    },
  },
];
